class CategoryEditView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el

    this.initCounter()
  }

  initCounter() {
    const $counters = this.$root.find('.js-counter')

    $counters.each((_, root) => {
      const $root = $(root)
      const updateCounter = () => {
        const count = $root.find('input, textarea').val().length
        $root.find('.js-counter-value').text(`${count} character${count !== 1 ? 's' : ''}`)
      }

      $root
        .find('input, textarea')
        .on('propertychange change click keyup input paste', updateCounter)
      updateCounter()
    })
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new CategoryEditView($('.category-edit-view'))
})
